import {
  IAddMaterialGoodsIssue,
  IUpdateMaterialGoodsIssue,
} from "mobx-stores/_models/material-inventory/material-goods-issue/material-goods-issue";
import { IMaterialGoodsIssueItemProperties } from "mobx-stores/_models/material-inventory/material-goods-issue/material-goods-issue-item";
import { BaseBussiness } from "../base";

class MaterialGoodsIssueBusiness extends BaseBussiness<
  IMaterialGoodsIssueItemProperties,
  IAddMaterialGoodsIssue,
  IUpdateMaterialGoodsIssue,
  IMaterialGoodsIssueItemProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }
}

export const materialGoodsIssueBusiness = new MaterialGoodsIssueBusiness(
  "/api/app/material-goods-issue"
);
